// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"22494251","486":"60cb258d"}[chunkId] + ".chunk.css";
};